import { Vestiging } from "@/entities/vestiging";
import { useMemo } from "react";
import { BaseFaciliteitenTable, SmartSelectAllButton, StationHeader } from "../../shared";
import { createColumns, Handlers } from "./columns-factory";

interface FaciliteitenDetailsForStationProps extends Handlers {
    stationCode: string;
    vestigingen: Vestiging[];
    vestigingenIdSelection: number[];
    onVestigingenSelectionChange: (vestigingId: number, selected: boolean) => void;
    onSelectAllForStation: (stationCode: string) => void;
    onDeselectAllForStation: (stationCode: string) => void;
}

export function FaciliteitenDetailsForStation({
    stationCode,
    vestigingen,
    vestigingenIdSelection,
    onVestigingenSelectionChange,
    onSelectAllForStation,
    onDeselectAllForStation,
    onUpdateOpeningstijd,
}: Readonly<FaciliteitenDetailsForStationProps>) {
    const selectableNsRetailVestigingen = vestigingen.filter((v) => v.isSelectableForSelectAll);

    const allSelected =
        selectableNsRetailVestigingen.length > 0 &&
        selectableNsRetailVestigingen.every((v) => vestigingenIdSelection.includes(v.beheerVestiging.id));
    const hasSelectableNsRetailVestigingen = selectableNsRetailVestigingen.length > 0;

    const handleSelectAll = () => {
        if (allSelected) {
            onDeselectAllForStation(stationCode);
        } else {
            onSelectAllForStation(stationCode);
        }
    };

    const columns = useMemo(
        () => createColumns({ onVestigingenSelectionChange, vestigingenIdSelection }, { onUpdateOpeningstijd }),
        [onUpdateOpeningstijd, onVestigingenSelectionChange, vestigingenIdSelection]
    );

    return (
        <div className="space-y-4">
            <div className="flex items-center justify-between">
                <StationHeader stationCode={stationCode}>
                    <SmartSelectAllButton
                        allSelected={allSelected}
                        hasSelectableItems={hasSelectableNsRetailVestigingen}
                        onToggleSelectAll={handleSelectAll}
                    />
                </StationHeader>
            </div>

            <BaseFaciliteitenTable
                stationCode={stationCode}
                vestigingen={vestigingen}
                columns={columns}
                columnWidths={["45%", "17%", "35%", "3%"]}
            />
        </div>
    );
}
